<template>
  <div>
    <b-modal ref="settingsmodal" class="tabs-modal" size="lg custom-overlay settingspopup" :hide-footer="true">
      <div slot="modal-header" class="w-100">
        <p class="float-left modal-title">Settings</p>
        <b-btn size="lg" class="float-right" variant="flat" @click="closeModal">
          <close-icon class="icon-default close modalclose"></close-icon>
        </b-btn>
      </div>
      <div class="col-md-10 mx-auto">
        <b-tabs pills vertical class="h-100" @input="tabSelected">
          <b-tab :title="setting.name" v-for="(setting,index) in settingsMenu" :key="setting.name">
            <div v-if="currentTabIndex==index" class="h-100">
              <component :is="setting.component" :settings="settings" @action="processAction"></component>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CloseIcon from "../../assets/close.svg";

import AccountSettings from "./AccountSettings";
import AppSettings from "./AppSettings";
import SecuritySettings from "./SecuritySettings";
import EmailSettings from "./EmailSettings";
import CronSettings from "./CronSettings";
import AppUpdateSettings from "./AppUpdateSettings";
import ConnectionMethodSettings from "./ConnectionMethodSettings";
// import GoogleSettings from "./GoogleSettings";


export default {
  name: "settings",
  components: {
    AccountSettings,
    AppSettings,
    SecuritySettings,
    EmailSettings,
    CronSettings,
    AppUpdateSettings,
    ConnectionMethodSettings,
    // GoogleSettings,
    CloseIcon
  },
  computed: {
    settings() {
      return this.$store.getters.getSettings;
    }
  },
  data() {
    return {
      currentTabIndex: 0,
      settingsMenu: [
        {
          name: "Account",
          component: "AccountSettings"
        },
        {
          name: "App",
          component: "AppSettings"
        },
        {
          name: "Security",
          component: "SecuritySettings"
        },
        {
          name: "Email Settings",
          component: "EmailSettings"
        },
        {
          name: "Cron",
          component: "CronSettings"
        },
        {
          name: "App Update",
          component: "AppUpdateSettings"
        },
        // {
        //   name: "Google Settings",
        //   component: "GoogleSettings"
        // },
        {
          name: "Connection method",
          component: "ConnectionMethodSettings"
        }
      ]
    };
  },
  methods: {
    showSettings() {},
    processAction(payload) {
      switch (payload.action) {
        case "loginActivity":
          this.$router.push({
            name: "Manage",
            params: { slug: "loginActivity" }
          });
          this.closeModal();
          break;
      }
    },
    closeModal() {
      this.$refs.settingsmodal.hide();
    },
    tabSelected(index) {
      this.currentTabIndex = index;
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Settings/Settings.vue